import React, { useState } from "react";
import "../assets/guardianFilters.css";

// Sentinel for the "show everything" option in the registration source filter.
// It is never sent to the API - selecting it just clears the filter.
const ALL_SOURCES = "__all__";

const GuardianFilters = ({
  locations,
  registrationSources = [],
  registrationSourcesTotal = 0,
  selectedSources = [],
  onSourceFilter,
  onLocationFilter,
  onSearchFilter,
  onExportCSV,
  onExportExcel,
  onExportPDF,
  onPrintTable,
  onColumnVisibility,
  columnVisibility,
  showColumnVisibility,
  toggleColumnVisibility,
  pageSize,
  onPageSizeChange,
  loading = false,
  canExport = true
}) => {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleLocationChange = (locationId) => {
    const newSelectedLocations = selectedLocations.includes(locationId)
      ? selectedLocations.filter((id) => id !== locationId)
      : [...selectedLocations, locationId];

    setSelectedLocations(newSelectedLocations);
    onLocationFilter(
      newSelectedLocations.length > 0 ? newSelectedLocations.join(",") : ""
    );
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearchFilter(value);
  };

  const clearFilters = () => {
    setSelectedLocations([]);
    setSearchTerm("");
    onLocationFilter("");
    onSourceFilter([]);
    onSearchFilter("");
  };

  return (
    <div
      className="guardian-filters"
      style={{
        width: "100%",
        border: "none",
        background: "transparent",
        margin: "0",
      }}
    >
      <div className="form-group">
        <label htmlFor="location">Filter by locations</label>
        <select
          id="location"
          className="form-control"
          multiple
          value={selectedLocations}
          onChange={(e) => {
            const selectedOptions = Array.from(
              e.target.selectedOptions,
              (option) => option.value
            );
            setSelectedLocations(selectedOptions);
            onLocationFilter(
              selectedOptions.length > 0 ? selectedOptions.join(",") : ""
            );
          }}
        >
          {locations.map((location) => (
            <option key={location.id} value={location.id}>
              {location.name}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="registration-source">Filter by registration source</label>
        <select
          id="registration-source"
          className="form-control"
          multiple
          // No source selected means no filter, which is what ALL_SOURCES shows
          value={selectedSources.length > 0 ? selectedSources : [ALL_SOURCES]}
          onChange={(e) => {
            const selectedOptions = Array.from(
              e.target.selectedOptions,
              (option) => option.value
            );

            // "All" is exclusive - picking it clears every other selection
            if (selectedOptions.includes(ALL_SOURCES)) {
              onSourceFilter([]);
              return;
            }

            onSourceFilter(selectedOptions);
          }}
        >
          <option value={ALL_SOURCES}>
            All registration sources ({registrationSourcesTotal})
          </option>
          {registrationSources.map((source) => (
            <option key={source.slug} value={source.slug}>
              {source.label} ({source.count})
            </option>
          ))}
        </select>
      </div>

      <div
        className="form-group"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <div className="property-table-entries " style={{ marginRight: "0px" }}>
          Show
          <select
            className="entries-select"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {[10, 25, 30, 50, 100].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          entries
        </div>
        <label
          htmlFor="search"
          style={{
            color: "#333",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
          }}
        >
          Search
        </label>
        <div style={{ flex: 1, position: 'relative' }}>
          <input
            style={{ width: '100%', paddingRight: loading ? '30px' : '12px' }}
            type="text"
            id="search"
            className="form-control"
            placeholder="Search by name, UGD, or email..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {loading && (
            <div style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: '12px',
              color: '#999'
            }}>
              ⏳
            </div>
          )}
        </div>
        {canExport && (
          <button
            className="btn btn-export-csv-property"
            style={{ float: "right", marginRight: 8 }}
            onClick={onExportCSV}
          >
            Export as CSV
          </button>
        )}
        {canExport && (
          <button
            className="btn btn-export-csv-property"
            style={{ float: "right", marginRight: 8 }}
            onClick={onExportExcel}
          >
            Export as Excel
          </button>
        )}
        {canExport && (
          <button
            className="btn btn-export-csv-property"
            style={{ float: "right", marginRight: 8 }}
            onClick={onExportPDF}
          >
            Export as PDF
          </button>
        )}
        <button
          className="btn btn-export-csv-property"
          style={{ float: "right", marginRight: 8 }}
          onClick={onPrintTable}
        >
          Print Table
        </button>
        <div style={{ position: "relative", display: "inline-block", float: "right", marginRight: 8 }}>
          <button
            className="btn btn-export-csv-property column-visibility-btn"
            onClick={onColumnVisibility}
          >
            Column visibility
          </button>
          {showColumnVisibility && (
            <div className="column-visibility-dropdown" style={{
              position: "absolute",
              top: "100%",
              right: 0,
              backgroundColor: "white",
              border: "1px solid #ddd",
              borderRadius: "4px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "12px",
              minWidth: "220px",
              zIndex: 1000,
              marginTop: "4px",
              fontFamily: "Montserrat, sans-serif"
            }}>
              <h4 style={{
                margin: "0 0 12px 0",
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
                borderBottom: "1px solid #eee",
                paddingBottom: "8px"
              }}>Toggle Columns:</h4>
              <div style={{ maxHeight: "400px", overflowY: "auto", paddingRight: "8px" }}>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.unique_guardian_number} onChange={() => toggleColumnVisibility('unique_guardian_number')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>UGD</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.name} onChange={() => toggleColumnVisibility('name')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Name</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.status} onChange={() => toggleColumnVisibility('status')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Status</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.email} onChange={() => toggleColumnVisibility('email')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Email</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.notes} onChange={() => toggleColumnVisibility('notes')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Internal Notes</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.payment_confirmed} onChange={() => toggleColumnVisibility('payment_confirmed')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Payment Confirmed</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.property_name} onChange={() => toggleColumnVisibility('property_name')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Property</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.license_fee} onChange={() => toggleColumnVisibility('license_fee')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>License Fee</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.actions} onChange={() => toggleColumnVisibility('actions')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Actions</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.salutation} onChange={() => toggleColumnVisibility('salutation')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Salutation</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.job_title} onChange={() => toggleColumnVisibility('job_title')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Job Title</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.address_1} onChange={() => toggleColumnVisibility('address_1')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Address 1</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.address_2} onChange={() => toggleColumnVisibility('address_2')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Address 2</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.address_3} onChange={() => toggleColumnVisibility('address_3')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Address 3</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.town} onChange={() => toggleColumnVisibility('town')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Town</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.postcode} onChange={() => toggleColumnVisibility('postcode')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Postcode</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.hear_about} onChange={() => toggleColumnVisibility('hear_about')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Hear About</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.registration_source} onChange={() => toggleColumnVisibility('registration_source')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Registration Source</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.phone_number} onChange={() => toggleColumnVisibility('phone_number')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Phone Number</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.mobile_number} onChange={() => toggleColumnVisibility('mobile_number')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Mobile Number</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.nationality} onChange={() => toggleColumnVisibility('nationality')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Nationality</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.religion} onChange={() => toggleColumnVisibility('religion')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Religion</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.gender} onChange={() => toggleColumnVisibility('gender')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Gender</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.date_of_birth} onChange={() => toggleColumnVisibility('date_of_birth')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Date of Birth</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.national_insurance_number} onChange={() => toggleColumnVisibility('national_insurance_number')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>National Insurance Number</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.on_newsletter_list} onChange={() => toggleColumnVisibility('on_newsletter_list')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>On Newsletter List</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.on_voluntary_work} onChange={() => toggleColumnVisibility('on_voluntary_work')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>On Voluntary Work</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.assigned_on} onChange={() => toggleColumnVisibility('assigned_on')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Assigned On</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.officer} onChange={() => toggleColumnVisibility('officer')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Officer</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.email_receive_marketing} onChange={() => toggleColumnVisibility('email_receive_marketing')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Email Receive Marketing</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.updated_by} onChange={() => toggleColumnVisibility('updated_by')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Updated By</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.share_data_other_organisation} onChange={() => toggleColumnVisibility('share_data_other_organisation')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Share Data Other Organisation</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.placed_date} onChange={() => toggleColumnVisibility('placed_date')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Placed Date</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.end_date} onChange={() => toggleColumnVisibility('end_date')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>End Date</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.notice_date_ntq} onChange={() => toggleColumnVisibility('notice_date_ntq')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Notice Date - NTQ</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.created_at} onChange={() => toggleColumnVisibility('created_at')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Created At</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", padding: "6px 0", cursor: "pointer", fontSize: "14px", color: "#555" }}>
                <input type="checkbox" checked={columnVisibility.updated_at} onChange={() => toggleColumnVisibility('updated_at')} style={{ marginRight: "10px", cursor: "pointer" }} />
                <span>Updated At</span>
              </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {(selectedLocations.length > 0 || selectedSources.length > 0 || searchTerm) && (
        <div className="form-group">
          <button className="btn btn-sm btn-default" onClick={clearFilters}>
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default GuardianFilters;
